import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { resetPassword } from "api";

import Dialog from "components/organisms/Dialog/Dialog";
import Button from "components/atoms/Button/Button";
import errorToast from "helpers/errorToast";

const UpdatePasswordDialog = function ({ showDialog, handleClose, email }) {
  const [isLoading, setIsLoading] = useState(false);
  const intl = useIntl();

  const handlePasswordResetClick = () => {
    setIsLoading(true);
    const bodyData = {
      username: email,
    };
    resetPassword(bodyData)
      .then(() => {
        setIsLoading(false);
        handleClose();
        toast(
          intl.formatMessage({
            id: "settings.your-details.passwordResetRequestSuccess",
            defaultMessage: "An email has been sent to you to reset your password",
          }),
          { type: "success" },
        );
      })
      .catch((err) => {
        setIsLoading(false);
        errorToast(
          err,
          intl.formatMessage({
            id: "settings.your-details.passwordResetRequestFail",
            defaultMessage: "Could not send request. Please try again later",
          }),
        );
      });
  };

  return (
    <Dialog
      title={intl.formatMessage({
        id: "login.passwordReset",
        defaultMessage: "Password reset",
      })}
      size="md"
      show={showDialog}
      onHide={handleClose}
    >
      <Row>
        <Col className="mb-30" xs={12}>
          <span className="text-body">
            <FormattedMessage
              id="settings.your-details.passwordResetInfo"
              defaultMessage="An email will be sent to <b>{email}</b> to reset your password.
          {lineBreak}
          Please note that you can only reset the password for an active account. If your account is not activated, or you have not received any reset instructions, please contact <a>support@cargobase.com</a>."
              values={{
                a: (chunks) => <a href="mailto:support@cargobase.com">{chunks}</a>,
                b: (chunks) => <b>{chunks}</b>,
                lineBreak: <br />,
                email,
              }}
            />
          </span>
        </Col>
      </Row>

      <Row className="mt-3">
        <Col lg={12} className="d-flex flex-row">
          <Button
            className="btn-grey"
            label={intl.formatMessage({
              id: "general.cancel",
              defaultMessage: "Cancel",
            })}
            onClick={handleClose}
          />
          <Button variant="success" className="ml-auto" onClick={handlePasswordResetClick} disabled={isLoading}>
            <FormattedMessage
              id={isLoading ? "general.loading" : "settings.your-details.requestPasswordReset"}
              defaultMessage={isLoading ? "Loading..." : "Reset my password"}
            />
          </Button>
        </Col>
      </Row>
    </Dialog>
  );
};

UpdatePasswordDialog.propTypes = {
  showDialog: PropTypes.bool,
  handleClose: PropTypes.func,
  email: PropTypes.string,
};

UpdatePasswordDialog.defaultProps = {
  showDialog: false,
  handleClose: null,
  email: "",
};

export default UpdatePasswordDialog;
